import { gql } from '__generated__';

export default gql(`
  query GetParticipantFieldImportsForEvent($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        title
        invoice_prefix
        participant_field_imports {
          id
          filename
          field {
            id
            title
            scope
            type
          }
          length
          errors_count
          ready_to_import
          validated_at
          importing
          imported_at
          confirmation_mail_sending
          created_at
          deletable
        }
        participant_fields {
          id
          title
          type
          scope
          choices {
            id
            title
          }
          products {
            id
          }
        }
      }
    }
  }
`);
